import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onOpenMessagesFlyout } from '../lib/messagesFlyout';

/**
 * Entity/collab callers still fire `openMessagesFlyout`.
 * Route them to the dedicated Messages page instead of a nav popover.
 */
export function MessagesOpenRedirect() {
  const navigate = useNavigate();

  useEffect(
    () =>
      onOpenMessagesFlyout((request) => {
        if (request.conversationId) {
          navigate(`/messages/${request.conversationId}`);
          return;
        }
        navigate('/messages', { state: { openMessages: request } });
      }),
    [navigate],
  );

  return null;
}
